import { Box, Group, Paper, Title } from '@mantine/core';
import type { JSX, ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, actions }: PageHeaderProps): JSX.Element {
  return (
    <Paper withBorder radius="md" shadow="sm" p="md" mb="md">
      <Group justify="space-between" align="center" wrap="wrap" style={{ maxWidth: '100%', minWidth: 0 }}>
        <Title order={1} size="h2" fw={700}>
          {title}
        </Title>
        {actions && <Box style={{ minWidth: 0, maxWidth: '100%' }}>{actions}</Box>}
      </Group>
    </Paper>
  );
}
